'use strict'

module.exports = function getTime () {
  return Date.now()
}
